import { render, staticRenderFns } from "./Shexiao.vue?vue&type=template&id=56c7b998&scoped=true&"
import script from "./Shexiao.vue?vue&type=script&lang=js&"
export * from "./Shexiao.vue?vue&type=script&lang=js&"
import style0 from "./Shexiao.vue?vue&type=style&index=0&id=56c7b998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c7b998",
  null
  
)

export default component.exports